import { useQuery } from '@hooks/reactQuery';

import { getConnectionLogs } from '@api/networkElements';

import { extractQueryParams } from '@utils/common';

import { INetworkElementsConnectionLogsListDTO } from '@interfaces/networkElements/dto/networkElements';
import { IConnectionLog } from '@interfaces/networkElements/networkElements';

import { refetchOptions } from '@constants/common';
import { NETWORK_ELEMENTS_CONNECTION_LOGS } from '@constants/queryKeys';

interface IUseQueryConnectionLogsReturned {
	connectionLogs: IConnectionLog[];
	countOfRecords: number;
	isLoadingConnectionLogs: boolean;
}

const useQueryConnectionLogs = (params: INetworkElementsConnectionLogsListDTO): IUseQueryConnectionLogsReturned => {
	const {
		page,
		pageSize,
		isEnabled,
	} = params;

	const {
		data,
		isLoading,
		isFetching,
	} = useQuery({
		queryKey: [NETWORK_ELEMENTS_CONNECTION_LOGS, params],
		queryFn: extractQueryParams(getConnectionLogs),
		enabled: [!!page, !!pageSize, isEnabled],
		...refetchOptions,
		staleTime: 0,
	});

	return {
		connectionLogs: data?.items || [],
		countOfRecords: data?.count || 0,
		isLoadingConnectionLogs: (isLoading && !!data)
			|| isFetching,
	};
};

export default useQueryConnectionLogs;
